import type { InjectionKey, Ref } from "vue";

/** Provided by a VTabList in bar mode: its items render as the buttons of a bottom tab bar. */
export const TAB_LIST_BAR: InjectionKey<Ref<boolean>> = Symbol("tabListBar");

/** The tabs a bar has moved under its "more" button; they hide themselves in the bar. */
export const TAB_BAR_OVERFLOW: InjectionKey<Ref<Set<number>>> = Symbol("tabBarOverflow");
